import { FC, useEffect, useRef, useState } from 'react'

type Props = {
  title: string
  ariaLabel: string
  src: string
  height: number | string
  nomargin?: boolean
  id?: string
  onLoad?: () => void
}
const DatawrapperChart: FC<Props> = ({
  title,
  ariaLabel,
  src,
  height: initialHeight,
  nomargin,
  onLoad,
}) => {
  const [height, setHeight] = useState(initialHeight)
  const iframeRef = useRef<HTMLIFrameElement>(null)

  /*const onLoadIframe = (e: React.SyntheticEvent<HTMLIFrameElement>) => {
    //console.log(e.currentTarget)
  }*/

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (
        event.data['datawrapper-height'] &&
        iframeRef.current?.contentWindow === event.source
      ) {
        const values = Object.values(event.data['datawrapper-height'])

        if (values.length) {
          setHeight(values[0] as number)
        }
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return (
    <iframe
      ref={iframeRef}
      title={title}
      aria-label={ariaLabel}
      src={src}
      scrolling="no"
      style={{
        display: 'block',
        marginTop: nomargin ? '0' : 'var(--spacing-lg)',
        marginBottom: nomargin ? '0' : 'var(--spacing-lg)',
        width: '100%',
        border: 'none',
        height: height,
      }}
      frameBorder={0}
      data-external="1"
      onLoad={onLoad}
    />
  )
}
export default DatawrapperChart
